var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseReportItemComponent } from 'app/reports/models/base-report-item-component';
var HtmlContentItemComponent = /** @class */ (function (_super) {
    __extends(HtmlContentItemComponent, _super);
    function HtmlContentItemComponent(domSanitizer) {
        var _this = _super.call(this) || this;
        _this.domSanitizer = domSanitizer;
        _this._classNames = [];
        return _this;
    }
    HtmlContentItemComponent.prototype.getHTMLClassNames = function () {
        return this._classNames;
    };
    HtmlContentItemComponent.prototype.ngOnInit = function () {
    };
    HtmlContentItemComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    HtmlContentItemComponent.prototype.setReportData = function (data, results, variables) {
        if (data && data.content) {
            var content = data.content;
            if (variables && variables.length) {
                // handle any variable substitutions here...
                variables.forEach(function (v) {
                    var id = "{{" + v.id + "}}";
                    var replace = v.value + "";
                    content = content.replace(id, replace);
                });
            }
            this.content = this.domSanitizer.bypassSecurityTrustHtml(content);
            if (data.classNames && data.classNames.length) {
                this._classNames = data.classNames.concat(this._classNames);
            }
        }
    };
    Object.defineProperty(HtmlContentItemComponent.prototype, "content", {
        get: function () {
            return this._content;
        },
        set: function (v) {
            this._content = v;
        },
        enumerable: true,
        configurable: true
    });
    return HtmlContentItemComponent;
}(BaseReportItemComponent));
export { HtmlContentItemComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/html-content-item/html-content-item.component.ts.pre-build-optimizer.js